import React, { useState } from 'react';
import AttendanceMaster from './AttendanceMaster';
import QuickMarkDashboard from './QuickMarkDashboard';
import { GLOBAL_ROLES } from './useAttendance';

const ALLOWED_ROLES = [...GLOBAL_ROLES, 'teacher'];

const btn = (bg) => ({
  width: '100%', padding: '12px', marginTop: 10, background: bg, color: '#fff', border: 'none',
  borderRadius: 10, fontSize: 15, fontWeight: 'bold', cursor: 'pointer'
});

// Always-visible entry point for the Master Attendance + WhatsApp features.
// Used by Principal / Admin / Admin1 dashboards. Logs the evaluated role so access problems are easy to spot.
export default function AttendanceLauncher({ user }) {
  const [open, setOpen] = useState(null); // 'master' | 'quick' | null
  const role = user && user.role;
  const allowed = ALLOWED_ROLES.includes(role);
  console.log('[AttendanceLauncher] evaluating role:', role, '| allowed:', allowed);

  return (
    <div className="card" style={{ padding: 20, background: '#f0fdf4', border: '2px solid #25d366' }}>
      <h3 style={{ marginBottom: 8, color: '#15803d' }}>📋 Master Attendance &amp; WhatsApp</h3>
      {allowed ? (
        <>
          <p style={{ fontSize: 14, color: '#374151', margin: 0 }}>
            Mark attendance for all classes, edit past dates, manage holidays and send WhatsApp reports.
          </p>
          <button style={btn('#16a34a')} onClick={() => setOpen('master')}>📋 Master Attendance &amp; WhatsApp</button>
          <button style={btn('#2563eb')} onClick={() => setOpen('quick')}>⚡ Quick-Mark All Classes</button>
        </>
      ) : (
        <p style={{ fontSize: 14, color: '#b91c1c', margin: 0 }}>
          Role "{String(role)}" does not have access to Master Attendance.
        </p>
      )}
      {allowed && open === 'master' && <AttendanceMaster user={user} onClose={() => setOpen(null)} />}
      {allowed && open === 'quick' && <QuickMarkDashboard user={user} onClose={() => setOpen(null)} />}
    </div>
  );
}
